import angular from 'angular';
import '../../services/notifications';
import '../../services/organization-user';
import { toArray } from 'lodash';

const module = angular.module('whyline.modals.select-place', [
  'whyline.services.notifications',
]);

const SelectPlaceModalController = function(
  $scope,
  $uibModalInstance,
  $translate,
  NotificationService,
  places,
) {
  'ngInject';

  $scope.places = toArray(places);
  $scope.selectedPlace = [];

  $scope.servicesSettings = {
    template: '<translate>{{option.name}}</translate>',
    externalIdProp: '',
    displayProp: 'name',
    idProp: '_id',
    searchField: 'name',
    enableSearch: true,
    showCheckAll: false,
    showUncheckAll: false,
    keyboardControls: true,
    selectedToTop: true,
    scrollable: true,
    smartButtonMaxItems: 1,
    closeOnSelect: true,
    selectionLimit: 1,
  };

  $scope.multiselectTranslations = {
    dynamicButtonTextSuffix: $translate.instant('multiselect_seleccionados'),
    buttonDefaultText: $translate.instant('select_option'),
    searchPlaceholder: $translate.instant('multiselect_buscar'),
  };

  this.save = () => {
    if ($scope.selectedPlace && $scope.selectedPlace.length > 0) {
      $uibModalInstance.close($scope.selectedPlace[0]);
    } else {
      NotificationService.Warning($translate.instant('at_least_one_place_error'));
    }
  };

  this.cancel = () => {
    $uibModalInstance.close('cancel');
  };
};

module.exports = module.controller(
  'SelectPlaceModalController',
  SelectPlaceModalController,
);
